module.exports = __webpack_public_path__ + "img/login-dialog.88bf3f56.png";